import { styled } from '@mui/material';
import React__default from 'react';
import { BrandclubProductCard } from '../components/BrandclubProductCard/index.js';
import BrandclubLoading from '../components/BrandclubLoading/index.js';
import { ProductGrid } from './SearchResultsStyles.js';

const Container = styled('div')({});
const SearchProductGrid = ({ loading, products, LinkComponent, containerWidthOverride, onShareClick, children, }) => {
    return (React__default.createElement(Container, null, loading ? (React__default.createElement(BrandclubLoading, { type: "productGrid" })) : (React__default.createElement(ProductGrid, { className: "grid", containerWidthOverride: containerWidthOverride },
        children,
        products.map((product, idx) => {
            return (React__default.createElement(BrandclubProductCard, { className: "fullsize_responsive", LinkComponent: LinkComponent, onShareClick: (e) => onShareClick(e, product), key: idx, product: product }));
        })))));
};

export { SearchProductGrid as default };
//# sourceMappingURL=SearchProductGrid.js.map
